import React, { useState, useEffect } from 'react';
import { Clock } from 'lucide-react';
import { adminService } from '../../services/adminService';
import { useTranslation } from '../../i18n/LocaleContext';

const AdminDashboard = () => {
  const { t } = useTranslation();
  const [statsData, setStatsData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      setLoading(true);
      const data = await adminService.getDashboardStats();
      setStatsData(data.stats);
    } catch (error) {
      console.error('Fetch stats error:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('vi-VN', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <p className="text-gray-400">{t('aDashLoading')}</p>
      </div>
    );
  }

  if (!statsData) {
    return (
      <div className="flex items-center justify-center h-64">
        <p className="text-gray-400">{t('aDashError')}</p>
      </div>
    );
  }

  const stats = [
    { title: t('aDashTotalBalance'), value: formatCurrency(statsData.total_balance) },
    { title: t('aDashOrdersToday'), value: statsData.orders_today },
    { title: t('aDashCompletedOrders'), value: statsData.total_registered },
    { title: t('aDashTotalUsers'), value: statsData.total_users },
    { title: t('aDashTotalDeposit'), value: formatCurrency(statsData.total_deposit) },
    { title: t('aDashTotalWithdraw'), value: formatCurrency(statsData.total_withdraw) }
  ];

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-white">{t('aDashTitle')}</h1>
        <p className="text-gray-400 mt-1">{t('aDashSubtitle')}</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {stats.map((stat, index) => (
            <div key={index} className="bg-gray-800 rounded-xl shadow-sm p-4 border border-gray-700">
              <h3 className="text-gray-400 text-sm mb-1">{stat.title}</h3>
              <p className="text-2xl font-bold text-white">{stat.value}</p>
            </div>
        ))}
      </div>

      <div className="mt-6 bg-gray-800 border border-gray-700 rounded-xl p-4">
        <div className="flex items-center gap-2">
          <Clock className="w-5 h-5 text-gray-400" />
          <div>
            <p className="font-medium text-white">{t('aDashPendingHeading')}</p>
            <p className="text-sm text-gray-400">
              {t('aDashPendingText', { deposits: statsData.pending_deposits, withdraws: statsData.pending_withdraws })}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
